import * as api from '../../api';
import { updateWebVersionActions } from './user-preferences.actions';

export const userPreferencesReducer = (state = api.ApiCallState({}), action) =>
  api.apiCallReducer(state, action, updateWebVersionActions);



// WEBPACK FOOTER //
// src/acct/preferences/user-preferences.reducer.js